import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

import rules from '../../../../../../../../constants/businessRules/businessRules';
import imageSources from '../../../../../../../../constants/imageSources/imageSources';
import { elementContentType } from '../../../../../../../../types';
import * as Styled from './styles';
import * as contentLibraryAction from '../../../../../../../../actions/contentLibrary';

const ImageElement = ({ content, width, imageHeight, elementIsSelected, dispatch }) => {
    const { paddingTop, paddingRight, paddingBottom, paddingLeft } = content;
    const imageWidth = width - (paddingLeft + paddingRight);
    const { src } = content;
    const isPlaceholder = content.src === 'PLACE_HOLDER';
    const computedHeight = isPlaceholder ? rules.IMAGE_PLACEHOLDER_HEIGHT : imageHeight;
    const placeHolderImageDimension = Math.min(imageWidth, computedHeight);

    return (
        <>
            <table style={{ width: '100%' }} cellSpacing="0" cellPadding="0">
                <tbody>
                    <tr>
                        <td>
                            {isPlaceholder ? (
                                <Styled.PlaceHolderDiv
                                    elementIsSelected={elementIsSelected}
                                    computedHeight={computedHeight}
                                    imageWidth={imageWidth}
                                    paddingBottom={paddingBottom}
                                    paddingLeft={paddingLeft}
                                    paddingTop={paddingTop}
                                    paddingRight={paddingRight}
                                >
                                    <Styled.ImageElementDiv
                                        placeHolderImageDimension={placeHolderImageDimension}
                                        tabIndex="0"
                                    >
                                        <img
                                            draggable="false"
                                            src={imageSources.PLACEHOLDERS.IMAGE_UPLOAD}
                                            alt="placeholder icon"
                                            style={{
                                                margin: '0 auto',
                                                height: placeHolderImageDimension,
                                                width: placeHolderImageDimension,
                                            }}
                                        />
                                        <Styled.ImageDimensionText
                                            placeHolderImageDimension={placeHolderImageDimension}
                                            imageWidth={imageWidth}
                                        >
                                            {parseInt(imageWidth, 10)} px
                                        </Styled.ImageDimensionText>
                                        {elementIsSelected && (
                                            <>
                                                <Styled.ContentOverlay />
                                                <Styled.IconDiv
                                                    as="label"
                                                    htmlFor="uploadImage"
                                                    aria-label="upload image"
                                                    onKeyDown={() =>
                                                        dispatch(contentLibraryAction.setContentLibraryTab('upload'))
                                                    }
                                                    onClick={() =>
                                                        dispatch(contentLibraryAction.setContentLibraryTab('upload'))
                                                    }
                                                    tabIndex="0"
                                                >
                                                    <Styled.Icon icon="arrow-alt-to-top" />
                                                </Styled.IconDiv>
                                            </>
                                        )}
                                    </Styled.ImageElementDiv>
                                </Styled.PlaceHolderDiv>
                            ) : (
                                <div style={{ height: computedHeight }}>
                                    <img
                                        draggable="false"
                                        src={src}
                                        alt={content.alt}
                                        style={{
                                            width: imageWidth,
                                            height: computedHeight,
                                            paddingTop,
                                            paddingBottom,
                                            paddingLeft,
                                            paddingRight,
                                        }}
                                    />
                                </div>
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
        </>
    );
};

const mapStateToProps = (state) => ({
    hasImageUploadIntegrationAccess: _get(state, 'session.features.F_IMAGE_UPLOAD', false),
    IsRawImageUploadEnabled: _get(state, 'session.user.features.EMAIL_DESIGNER_RAW_IMAGE_UPLOA', false),
    isPublicPreview: _get(state, 'session.integration', '') === 'PUBLIC_PREVIEW',
});

ImageElement.propTypes = {
    content: elementContentType.isRequired,
    width: PropTypes.number.isRequired,
    imageHeight: PropTypes.number.isRequired,
    elementIsSelected: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(ImageElement);
